import React, { lazy } from "react";
import { PATH_APP } from "./paths";
import { Redirect } from "react-router-dom";
import Layouts from "../Layouts/Dashboard";

// ----------------------------------------------------------------------

const HomeRoutes = {
  path: "*",
  layout: Layouts,
  routes: [
    {
      exact: true,
      path: PATH_APP.index,
      component: lazy(() => import("./../views/Login")),
    },
    {
      exact: true,
      path: PATH_APP.adminBoardCast,
      component: lazy(() => import("./../views/broadcast")),
    },
    {
      exact: true,
      path: PATH_APP.notification,
      component: lazy(() => import("./../views/notificationList")),
    },
    {
      exact: true,
      path: PATH_APP.insertProgram,
      component: lazy(() => import("./../views/notification-list-new")),
    },
    {
      exact: true,
      path: PATH_APP.insertProgramTopfan,
      component: lazy(() => import("./../views/programsTopfan/insert")),
    },
    {
      exact: true,
      path: PATH_APP.users,
      component: lazy(() => import("./../views/users")),
    },
    {
      exact: true,
      path: PATH_APP.groupList,
      component: lazy(() => import("./../views/groupList")),
    },
    {
      exact: true,
      path: PATH_APP.notiLog,
      component: lazy(() => import("./../views/notiLog")),
    },
    {
      exact: true,
      path: PATH_APP.test_notification,
      component: lazy(() => import("./../views/test_notification")),
    },
    {
      exact: true,
      path: PATH_APP.notificationNew,
      component: lazy(() => import("./../views/notification-list-new")),
    },
  ],
};

export default HomeRoutes;
